<template>
  <a-card :bordered="false">
    <!-- 顶部筛选区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="角色名称">
              <a-input v-model.trim="queryParam.roleName" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>
      <a-button type="dashed" v-if="config.hasAlert" @click="tableOption">{{ optionAlertShow && '关闭' || '开启' }} alert</a-button>
    </div>

    <!-- 数据网格 -->
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :alert="options.alert"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
      :rowSelection="options.rowSelection">
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>

      <span slot="action" slot-scope="text, record">
        <a v-if="record.type == 1 || record.type == 3" @click="handlePrivilege(record)">分配权限</a>
        <a v-if="record.type == 2" @click="handleEdit(record)">编辑</a>
        <a-divider v-if="record.type == 2" type="vertical"/>
        <a-dropdown v-if="record.type == 2">
          <a class="ant-dropdown-link"> 更多<a-icon type="down"/></a>
          <a-menu slot="overlay">
            <a-menu-item><a @click="handlePrivilege(record)">分配权限</a></a-menu-item>
            <a-menu-item><a @click="handleDel(record)">删除</a></a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>

    <a-modal title="编辑" style="top: 20px;" :width="450" v-model="visible" @ok="handleOk" :confirmLoading="confirmLoading">
      <a-form :form="form">
        <a-form-item label="角色名称" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            v-model="mdl.roleName"
            placeholder="角色名称"
            v-decorator="['roleName',
            { initialValue: mdl.roleName, rules: [{ required: true, message: '请输入角色名称'}]}]" />
        </a-form-item>

        <a-form-item v-if="mdl.id == null" label="角色类型" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            v-model="mdl.type"
            placeholder="请选择角色类型"
            v-decorator="['type',
            { initialValue: '', rules: [{ required: true, message: '请选择角色类型'}]}]">
            <a-select-option v-for="(item, index) in typeSelect" :key="index" :value="item.value">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        

        <a-form-item label="备注" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-textarea v-model="mdl.remark" placeholder="请输入备注" :autosize="{ minRows: 3, maxRows: 6 }" />
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal title="设置权限" style="top: 80px;" :width="360" :heigh="720" v-model="privilege" @ok="handlePrivilegeOk" :confirmLoading="confirmLoading">
      <a-tree 
        checkable
        :expandedKeys="expandedKeys"
        :autoExpandParent="autoExpandParent"
        v-model="selectedKeys"
        @expand="onExpand"
        @check="onCheck"
        :treeData="treeData"
      />
    </a-modal>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import { rolePage, roleUpdate, roleSave, roleDelete, privilegeTree, privilegeFindPrivilegeByRole, roleSetProvollege } from '@/api/sys'

export default {
  name: 'Role',
  components: {
    STable
  },
  data () {
    return {
      pageSizeOptionsList:['10'],
      visible: false,
      confirmLoading: false,
      privilege: false,
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '角色名称',
          dataIndex: 'roleName'
        },
        {
          title: '角色类型',
          dataIndex: 'typeName'
        },
        {
          title: '备注',
          dataIndex: 'remark'
        },
        {
          title: '操作',
          width: '130px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return rolePage(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.data
          })
      },
      
      selectedRowKeys: [],
      selectedRows: [],

      autoExpandParent: true,
      selectedKeys: [],
      expandedKeys: [],
      treeData: null,

      typeSelect: null,

      // custom table alert & rowSelection
      options: {
        alert: { show: false, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created () {
    this.tableOption()
    this.loadtreeData()
  },
  // watch: {
  //   checkedKeys(val) {
  //     console.log('onCheck', val)
  //   }
  // },
  methods: {
    loadtreeData (treeNode) {
      new Promise(resolve => {
        const data = privilegeTree().then(res => { return res.data })
        resolve(data)
      }).then(res => {
        this.treeData = res
      })
      this.typeSelect = this.$store.getters.codeList.role_type
    },
    onExpand (expandedKeys) {
      // console.log('onExpand', expandedKeys)
      // 如果没有将autoExpandParent设置为false，如果子元素被展开，则父元素不能折叠。
      // 或者，您可以删除所有展开的子键。
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    onCheck (selectedKeys) {
      this.selectedKeys = selectedKeys
    },
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: false, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleEdit (record) {
      this.mdl = Object.assign({}, record)
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleAdd () {
      this.mdl = {}
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleOk () {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          if (this.mdl.id !== undefined) {
            console.log("角色类型:"+this.mdl)
            roleUpdate(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              }).catch((e) => {
                console.log(e)
              }).finally(() => {
                this.confirmLoading = false
              })
          } else {
            roleSave(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              }).catch((e) => {
                console.log(e)
              }).finally(() => {
                this.confirmLoading = false
              })
          }
        }
      })
    },
    handlePrivilege (record) {
      this.mdl = Object.assign({}, record)
      let nthis = this
      privilegeFindPrivilegeByRole({ 'roleId': this.mdl.id }).then(res => {
        let ids = new Array()
        for (let i = 0; i < res.data.length; i++) {
          if (String(res.data[i].privilegeId).indexOf('M') < 0) {
            ids.push(String(res.data[i].privilegeId))
          }
        }
        nthis.selectedKeys = ids 
        nthis.expandedKeys = nthis.selectedKeys
      })
      this.privilege = true
    },
    handlePrivilegeOk () {
      let privileges = ''
      for (let i = 0,len = this.selectedKeys.length; i < len; i++) {
        if (this.selectedKeys[i] != undefined && String(this.selectedKeys[i]).indexOf('M') < 0) {
          privileges += this.selectedKeys[i] + ','
        }
      }
      privileges = privileges.substring(0, privileges.length - 1)
      this.confirmLoading = true
      roleSetProvollege({ 'roleId': this.mdl.id, 'privileges': privileges}).then(res => {
        if (res.code === '0') {
          this.$refs.table.refresh()
          this.privilege = false
        }
      }).catch((e) => {
        console.log(e)
      }).finally(() => {
        this.confirmLoading = false
        this.form = this.$form.createForm(this)
      })
    },
    handleDel (record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk () {
          return roleDelete({ 'ids': record.id })
            .then(res => {
              if(res.code ==='0') {
                nthis.$refs.table.refresh()
              }
            }).catch((e) => {
              console.log(e)
            }).finally(() => {
            })
        },
        onCancel () {
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>
